import React from 'react';
import { FileText, Trash2, Clock, BookOpen, CheckCircle2, CircleOff } from "lucide-react";
import { useLanguage } from '../contexts/LanguageContext';

const DocumentCard = ({ 
  title, 
  date, 
  chapters_count, 
  document,
  onView, 
  onDelete,
  published,
  canTogglePublished = false,
  onTogglePublished,
  canDelete = false,
  selectable = false,
  selected = false,
  onToggleSelect,
}) => {
  const { t } = useLanguage();
  // Construire l'URL complète de l'image de couverture (interop dev/prod)
let coverImageUrl = null;
if (document.cover_image) {
  coverImageUrl = document.cover_image;
}

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden hover:shadow-md transition-shadow">
      {/* Image de couverture - Cliquable pour ouvrir le détail */}
      <div 
        className="h-48 bg-gray-100 relative overflow-hidden"
      >
        {selectable && (
          <div className="absolute top-2 left-2 z-10">
            <input
              type="checkbox"
              checked={selected}
              onChange={() => onToggleSelect && onToggleSelect()}
              className="w-4 h-4 accent-primary cursor-pointer rounded"
            />
          </div>
        )}
        {/* Toggle Publié / Non publié en overlay sur la cover */}
        <div className="absolute top-2 right-2 z-10">
          {canTogglePublished ? (
            <button
              type="button"
              onClick={onTogglePublished}
              className={`inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium border shadow-sm transition-colors ${published ? 'bg-green-500 border-green-600 text-white' : 'bg-gray-200 border-gray-400 text-gray-700'} cursor-pointer hover:opacity-90`}
            >
              <span
                className={`inline-flex items-center justify-center w-8 h-4 rounded-full mr-1 transition-colors ${published ? 'bg-green-200' : 'bg-gray-400'}`}
              >
                <span
                  className={`block w-3 h-3 bg-white rounded-full shadow transform transition-transform ${published ? 'translate-x-2' : '-translate-x-2'}`}
                />
              </span>
              {published ? (
                <span className="flex items-center gap-1">
                  <CheckCircle2 size={14} />
                  <span>{t('documents.card.published')}</span>
                </span>
              ) : (
                <span className="flex items-center gap-1">
                  <CircleOff size={14} />
                  <span>{t('documents.card.unpublished')}</span>
                </span>
              )}
            </button>
          ) : (
            <div
              className={`inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium border shadow-sm ${published ? 'bg-green-50 border-green-200 text-green-700' : 'bg-gray-100 border-gray-200 text-gray-600'}`}
            >
              {published ? (
                <>
                  <CheckCircle2 size={14} />
                  <span>{t('documents.card.published')}</span>
                </>
              ) : (
                <>
                  <CircleOff size={14} />
                  <span>{t('documents.card.unpublished')}</span>
                </>
              )}
            </div>
          )}
        </div>

        {coverImageUrl ? (
          <img 
            src={coverImageUrl} 
            alt={`${t('documents.card.coverAltPrefix')} ${title}`}
            className="w-full h-full object-cover"
            onError={(e) => {
              console.log('DocumentCard - Image failed to load:', coverImageUrl);
              console.log('DocumentCard - Error event:', e);
              e.target.style.display = 'none';
              e.target.nextSibling.style.display = 'flex';
            }}
          />
        ) : null}
        <div className="w-full h-full bg-primary flex items-center justify-center text-white" 
             style={{ display: coverImageUrl ? 'none' : 'flex' }}>
          <FileText size={48} />
        </div>
        
        {/* Overlay hover pour indiquer que c'est cliquable */}
        <div className="absolute inset-0 bg-black opacity-0 transition-opacity pointer-events-none" />
      </div>
      
      <div className="p-1 sm:p-3 border-b">
        <div className="flex items-start justify-between">
          <div className="flex-1">
            <h3 className="font-medium text-gray-900 text-base sm:text-lg">{title}</h3>
            <div className="flex items-center gap-2 text-xs sm:text-sm text-gray-500 mt-0.5 sm:mt-1">
              <Clock size={14} />
              <span>{date}</span>
              <span>•</span>
              <span>
                {chapters_count} {chapters_count === 1 ? t('documents.card.chaptersSingular') : t('documents.card.chaptersPlural')}
              </span>
            </div>
          </div>
          {/* <button className="text-gray-400 hover:text-gray-600">
            <MoreVertical size={18} />
          </button> */}
        </div>
      </div>
      
      <div className="bg-gray-50 grid grid-cols-2 divide-x divide-gray-200">
        <button 
          onClick={onView}
          className="flex flex-col sm:flex-row items-center justify-center gap-1 sm:gap-2 py-3 text-primary hover:bg-primary-50 transition-colors"
          title={t('documents.card.tooltipRead')}
        >
          <BookOpen size={18} />
          <span className="hidden sm:inline text-sm font-medium">{t('documents.card.read')}</span>
        </button>
        {canDelete && (
          <button 
            type="button"
            onClick={onDelete}
            className="flex flex-col sm:flex-row items-center justify-center gap-1 sm:gap-2 py-3 text-red-600 hover:bg-red-50 transition-colors"
            title={t('documents.card.tooltipDelete')}
          >
            <Trash2 size={18} />
            <span className="hidden sm:inline text-sm font-medium">{t('documents.buttons.delete')}</span>
          </button>
        )}
      </div>
    </div>
  );
};

export default DocumentCard;
